<template>
  <v1-index
      v-if="['42', '41'].includes(props.currentQa.sonQueType)"
      :current-qa="props.currentQa"
  />

  <v2-index
      v-else-if="['43', '44'].includes(props.currentQa.sonQueType)"
      :current-qa="props.currentQa"
  />

</template>

<script setup>
import V1Index from "@/views/examCenter/taxDigitalAccount/v1Index.vue";
import V2Index from '@/views/examCenter/taxDigitalAccountV2'

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})


</script>

<style scoped lang="scss">

</style>
